export enum CookieName {
  USER_ID = "userId",
  REFERRAL_CODE = "referralCode",
  REFERRAL_RESPONSE = "referralResponse",
  NEW_USER_EVENT = "newUserEvent",
  FBCLID = "_fbc",
  MAPPED_REFERRED_BY = "mappedReferredBy",
  ONBOARDING_MAPPED_MODAL = "onboardingMappedModal",
  SYNC_TOKEN_EXPIRED = "syncTokenExpired",
  SOURCE_PARAMS = "sourceParams",
  EMAIL_AUTH_PENDING = "gondola-email-auth-pending",
  INVITE_LINK_TOKEN = "inviteLinkToken",
  // Connect context for a third-party OAuth flow (e.g. ChatGPT): set at sign-in
  // so onboarding can show the "finish setup" banner and return the member to
  // the consent screen, even when sign-in drops them onto a route that doesn't
  // pass back through /oauth/authorize.
  OAUTH_CONNECT = "gondolaOauthConnect",
  // Set when a member arrives via /mcp/invite/[code]. Survives the multi-step
  // onboarding (each step is its own route, so query params do not) and lets the
  // finish screen tell them to head back to their AI agent.
  MCP_INVITE = "gondolaMcpInvite",
}
